"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_redux_1 = require("react-redux");
const react_1 = require("react");
const native_1 = require("@react-navigation/native");
const selectors_1 = require("../../store/redux/selectors");
const NavigationWrapperWeb_1 = __importDefault(require("../common/NavigationWrapperWeb"));
const SetupWeb_1 = __importDefault(require("../SetupWeb"));
const userHandlers_1 = require("../../handlers/userHandlers");
const PilotPassengerToggleWeb_1 = __importDefault(require("../common/PilotPassengerToggleWeb"));
const TabManagerWeb_1 = __importDefault(require("../common/TabManagerWeb"));
const SearchWeb_1 = __importDefault(require("./SearchWeb"));
const PublishFlightWeb_1 = __importDefault(require("./PublishFlightWeb"));
const FlightsNearYouWeb_1 = __importDefault(require("./FlightsNearYouWeb"));
const images_1 = require("../../services/images");
const SearchResultsWeb_1 = __importDefault(require("./SearchResultsWeb"));
const flight_1 = require("../../store/redux/flight");
const react_i18next_1 = require("react-i18next");
const helper_1 = require("../../services/helper");
const HomeWeb = () => {
    (0, native_1.useFocusEffect)((0, react_1.useCallback)(() => {
        (0, userHandlers_1.getUserDetailsHandler)();
    }, []));
    const state = (0, native_1.useNavigation)().getState();
    const isFocused = (0, native_1.useIsFocused)();
    const dispatch = (0, react_redux_1.useDispatch)();
    (0, react_1.useEffect)(() => {
        const routeName = state?.routes[state.index]?.name;
        if (routeName && !['FlightDetails', 'Home', "RequestDetails", "Payment"].includes(routeName) && !isFocused) {
            setShowResults(false);
            setTab('search');
            dispatch((0, flight_1.resetPublishStateAction)());
            dispatch((0, flight_1.resetSearchStateAction)());
        }
    }, [isFocused]);
    const [activeTab, setTab] = (0, react_1.useState)("search");
    const [showResults, setShowResults] = (0, react_1.useState)(false);
    const user = (0, react_redux_1.useSelector)(selectors_1.getUser);
    const asAPilot = (0, react_redux_1.useSelector)(selectors_1.getAsAPilot);
    const lng = user?.language;
    (0, react_1.useEffect)(() => {
        if (lng != null) {
            (0, helper_1.setUserLanguage)(lng);
        }
    }, [lng]);
    const [t] = (0, react_i18next_1.useTranslation)("i18n");
    const newUser = (0, react_redux_1.useSelector)(selectors_1.getNewUser);
    const isSearch = activeTab === "search";
    if (newUser) {
        return (0, jsx_runtime_1.jsx)(SetupWeb_1.default, {});
    }
    const homeTabs = [
        { label: `${t("tab_web.search")}`, name: `search`, icon: images_1.icons.Search, iconActive: images_1.icons.SearchActive },
        { label: `${t("tab_web.publish")}`, name: `publish`, icon: images_1.icons.Publish, iconActive: images_1.icons.PublishActive }
    ];
    return ((0, jsx_runtime_1.jsx)(NavigationWrapperWeb_1.default, { children: showResults ?
            (0, jsx_runtime_1.jsx)(SearchResultsWeb_1.default, { setShowResults: setShowResults, asAPilot: asAPilot }) :
            (0, jsx_runtime_1.jsxs)("div", { className: "home", children: [(0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsxs)("span", { className: "title", children: [t("start_web.hello"), " ", user ? user.username : '', "!"] }) }), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("span", { className: "title-thin", children: t("start_web.where") }) }), user?.is_pilot &&
                        (0, jsx_runtime_1.jsx)(PilotPassengerToggleWeb_1.default, {}), (0, jsx_runtime_1.jsx)(TabManagerWeb_1.default, { setTab: setTab, tabs: homeTabs, activeTab: activeTab }), isSearch ? (0, jsx_runtime_1.jsx)(SearchWeb_1.default, { setShowResults: setShowResults, searchFlightRequests: asAPilot }) : (0, jsx_runtime_1.jsx)(PublishFlightWeb_1.default, { asAPilot: asAPilot }), isSearch && (0, jsx_runtime_1.jsx)(FlightsNearYouWeb_1.default, {})] }) }));
};
exports.default = HomeWeb;
